module.exports = __webpack_public_path__ + "img/Phone.dd4bb2e2.svg";